<template>
  <div class="container is-fluid">
    <div class="box has-background-light">
      <div class="level">
        <div class="level-left">
          <h5 class="title is-5 has-text-primary">Balanço Patrimonial</h5>
        </div>
        <div class="level-right">
          <button
            class="button is-primary is-rounded is-small"
            @click="processar()"
            :disabled="cmbPeriodoPerfil.estaFechado"
          >
            <span class="icon is-small">
              <i class="fas fa-cog"></i>
            </span>
            <span>Processar</span>
          </button>
        </div>
      </div>

      <form @submit.prevent="filterRecords" class="filter-form">
        <div class="columns is-multiline is-mobile">
          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Tipo de Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbTipoPeriodo" @change="selectTipoPeriodo()">
                    <option value="0" disabled>Selecione um tipo de período</option>
                    <option v-for="td in tiposPeriodo" :key="td.id" :value="td.id">
                      {{ td.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Perfil</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPerfil" @change="selectPerfil()">
                    <option value="0" disabled>Selecione um perfil</option>
                    <option v-for="perfilUsuario in perfisUsuario" :key="perfilUsuario.id" :value="perfilUsuario.perfil.id">
                      {{ perfilUsuario.perfil.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPeriodoPerfil" @change="selectPeriodoPerfil()">
                    <option value="0" disabled>Selecione um período</option>
                    <option v-for="periodoPerfil in periodosPerfis" :key="periodoPerfil.id" :value="periodoPerfil">
                      {{ periodoPerfil.periodo.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Balanço Patrimonial</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbBalancoPatrimonialVersao">
                    <option value="0" disabled>Selecione um balanço patrimonial</option>
                    <option v-for="bp in balancosPatrimoniais" :key="bp.id" :value="bp.balanco_patrimonial_versao">
                      {{ bp.balanco_patrimonial_versao.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small"></label>
              <div class="control">
                <button type="submit" class="button is-primary is-rounded is-small">
                  <span class="icon is-small">
                    <i class="fas fa-filter"></i>
                  </span>
                  <span>Filtrar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal" :class="{ 'is-active': isProcessing }">
      <div class="modal-background" @click="isProcessing = false"></div>
      <div class="modal-content">
        <div class="box">
          <progress class="progress is-primary is-large" max="100"></progress>
          <p class="has-text-centered">Processando...</p>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="isProcessing = false"></button>
    </div>

    <div v-show="showInfo">
      <div class="columns" v-show="analiseDinamicaBalanco.length">
        <div class="column is-three-fifths">
          <div class="card">
            <header class="card-header has-background-primary has-text-white">
              <p class="card-header-title has-text-white">Análise Dinâmica do Balanço</p>
            </header>
            <div class="card-content">
              <apexchart type="treemap" height="350" :options="chartOptions" :series="series"></apexchart>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="card">
            <header class="card-header has-background-primary has-text-white">
              <p class="card-header-title has-text-white">Situação</p>
            </header>
            <div class="card-content has-background-primary-light">
              <h1 class="has-text-success-dark is-size-4 has-text-centered">{{ situacaoAnaliseDinamica }}</h1>
            </div>
            <footer class="card-footer">
              <p class="card-footer-item is-size-7">{{ helpSituacao }}</p>
            </footer>
          </div>

          <div class="card" style="margin-top: 1rem;">
            <header class="card-header has-background-primary has-text-white">
              <p class="card-header-title has-text-white">Indicadores</p>
            </header>
            <div class="card-content">
              <div class="table-container">
                <table class="table is-fullwidth is-narrow is-hoverable">
                  <thead>
                    <tr class="has-background-grey-lighter">
                      <th class="is-size-7">Indicador</th>
                      <th class="is-size-7 has-text-right">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="is-size-7" data-tooltip="Ativo Circulante Financeiro - Passivo Circulante Financeiro">
                        <strong>T - Saldo em Tesouraria</strong>
                      </td>
                      <td class="is-size-7 has-text-right">{{ valorST | numberFormat }}</td>
                    </tr>
                    <tr>
                      <td class="is-size-7" data-tooltip="Ativo Circulante Operacional - Passivo Circulante Operacional">
                        <strong>NCG - Necessidade de Capital de Giro</strong>
                      </td>
                      <td class="is-size-7 has-text-right">{{ valorNCG | numberFormat }}</td>
                    </tr>
                    <tr>
                      <td class="is-size-7" data-tooltip="Passivo Não Circulante - Ativo Não Circulante">
                        <strong>CDG - Capital de Giro</strong>
                      </td>
                      <td class="is-size-7 has-text-right">{{ valorCDG | numberFormat }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box has-background-light">
        <div class="tags">
          <span class="has-text-weight-bold">Legendas:</span>
          <span class="tag is-danger">Ativo Circulante Financeiro</span>
          <span class="tag is-info">Ativo Circulante Operacional</span>
          <span class="tag is-warning">Ativo Não Circulante</span>
        </div>
      </div>

      <!-- <div class="columns"> -->
        <div>
          <div class="card" v-if="cmbBalancoPatrimonialVersao != 0">
            <header class="card-header has-background-success has-text-white">
              <p class="card-header-title has-text-white">Ativo</p>
            </header>
            <div class="card-content">
              <div class="table-container">
                <table class="table is-fullwidth is-narrow is-hoverable">
                  <thead>
                    <tr class="has-background-grey-lighter">
                      <th class="is-size-7"></th>
                      <th class="is-size-7 has-text-centered">{{ anoMesReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered has-text-grey-light">AV%</th>
                      <th class="is-size-7 has-text-centered">{{ anoMesMesAnteriorReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered has-text-grey-light">AH%</th>
                      <th class="is-size-7 has-text-centered" v-if="cmbTipoPeriodo != 6">{{ anoMesAnoAnteriorReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered has-text-grey-light" v-if="cmbTipoPeriodo != 6">AH%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bp in balancosPatrimoniaisPeriodo" :key="bp.id">
                      <td
                        :class="renderCoresADB(bp.balanco_patrimonial_versao_config)"
                        v-if="bp.balanco_patrimonial_versao_config.e_negrito && bp.balanco_patrimonial_versao_config.destino == 'A'"
                      >
                        <strong class="is-size-7">{{ bp.balanco_patrimonial_versao_config.descricao }}</strong>
                      </td>
                      <td
                        :class="renderCoresADB(bp.balanco_patrimonial_versao_config)"
                        v-if="!bp.balanco_patrimonial_versao_config.e_negrito && bp.balanco_patrimonial_versao_config.destino == 'A'"
                      >
                        <span class="is-size-7">{{ bp.balanco_patrimonial_versao_config.descricao }}</span>
                      </td>

                      <td class="is-size-7 has-text-centered" v-if="bp.balanco_patrimonial_versao_config.destino == 'A'">
                        {{ bp.valor | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-primary has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A'">
                        {{ bp.perc_av | numberFormat }}
                      </td>

                      <td class="is-size-7 has-text-centered" v-if="bp.balanco_patrimonial_versao_config.destino == 'A'">
                        {{ bp.valorMesAnterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-success has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && bp.cor_ah_mes_anterior == '1'">
                        {{ bp.perc_ah_mes_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-danger has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && bp.cor_ah_mes_anterior == '2'">
                        {{ bp.perc_ah_mes_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-info has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && bp.cor_ah_mes_anterior == '3'">
                        {{ bp.perc_ah_mes_anterior | numberFormat }}
                      </td>

                      <td class="is-size-7 has-text-centered" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && cmbTipoPeriodo != '6'">
                        {{ bp.valorAnoAnterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-success has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && bp.cor_ah_ano_anterior == '1' && cmbTipoPeriodo != '6'">
                        {{ bp.perc_ah_ano_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-danger has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && bp.cor_ah_ano_anterior == '2' && cmbTipoPeriodo != '6'">
                        {{ bp.perc_ah_ano_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-info has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'A' && bp.cor_ah_ano_anterior == '3' && cmbTipoPeriodo != '6'">
                        {{ bp.perc_ah_ano_anterior | numberFormat }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <br>

        <div>
          <div class="card" v-if="cmbBalancoPatrimonialVersao != 0">
            <header class="card-header has-background-info has-text-white">
              <p class="card-header-title has-text-white">Passivo</p>
            </header>
            <div class="card-content">
              <div class="table-container">
                <table class="table is-fullwidth is-narrow is-hoverable">
                  <thead>
                    <tr class="has-background-grey-lighter">
                      <th class="is-size-7"></th>
                      <th class="is-size-7 has-text-centered">{{ anoMesReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered has-text-grey-light">AV%</th>
                      <th class="is-size-7 has-text-centered">{{ anoMesMesAnteriorReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered has-text-grey-light">AH%</th>
                      <th class="is-size-7 has-text-centered" v-if="cmbTipoPeriodo != 6">{{ anoMesAnoAnteriorReferencia | datePorTipo(cmbTipoPeriodo) }}</th>
                      <th class="is-size-7 has-text-centered has-text-grey-light" v-if="cmbTipoPeriodo != 6">AH%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bp in balancosPatrimoniaisPeriodo" :key="bp.id">
                      <td
                        :class="renderCoresADB(bp.balanco_patrimonial_versao_config)"
                        v-if="bp.balanco_patrimonial_versao_config.e_negrito && bp.balanco_patrimonial_versao_config.destino == 'P'"
                      >
                        <strong class="is-size-7">{{ bp.balanco_patrimonial_versao_config.descricao }}</strong>
                      </td>
                      <td
                        :class="renderCoresADB(bp.balanco_patrimonial_versao_config)"
                        v-if="!bp.balanco_patrimonial_versao_config.e_negrito && bp.balanco_patrimonial_versao_config.destino == 'P'"
                      >
                        <span class="is-size-7">{{ bp.balanco_patrimonial_versao_config.descricao }}</span>
                      </td>

                      <td class="is-size-7 has-text-centered" v-if="bp.balanco_patrimonial_versao_config.destino == 'P'">
                        {{ bp.valor | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-primary has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P'">
                        {{ bp.perc_av | numberFormat }}
                      </td>

                      <td class="is-size-7 has-text-centered" v-if="bp.balanco_patrimonial_versao_config.destino == 'P'">
                        {{ bp.valorMesAnterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-success has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && bp.cor_ah_mes_anterior == '1'">
                        {{ bp.perc_ah_mes_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-danger has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && bp.cor_ah_mes_anterior == '2'">
                        {{ bp.perc_ah_mes_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-info has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && bp.cor_ah_mes_anterior == '3'">
                        {{ bp.perc_ah_mes_anterior | numberFormat }}
                      </td>

                      <td class="is-size-7 has-text-centered" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && cmbTipoPeriodo != '6'">
                        {{ bp.valorAnoAnterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-success has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && bp.cor_ah_ano_anterior == '1' && cmbTipoPeriodo != '6'">
                        {{ bp.perc_ah_ano_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-danger has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && bp.cor_ah_ano_anterior == '2' && cmbTipoPeriodo != '6'">
                        {{ bp.perc_ah_ano_anterior | numberFormat }}
                      </td>
                      <td class="is-size-7 has-text-centered has-text-info has-text-weight-bold" v-if="bp.balanco_patrimonial_versao_config.destino == 'P' && bp.cor_ah_ano_anterior == '3' && cmbTipoPeriodo != '6'">
                        {{ bp.perc_ah_ano_anterior | numberFormat }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'BalancoPatrimonialPeriodo',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      periodosPerfis: [],
      perfisUsuario: [],
      balancosPatrimoniais: [],
      balancosPatrimoniaisPeriodo: [],
      analiseDinamicaBalanco: [],
      linhasBalancoPatrimonial: [],
      tiposPeriodo: [],
      series: [],
      chartOptions: {
        legend: { show: false },
        chart: { height: 350, type: 'treemap' },
        title: { text: 'Análise Dinâmica do Balanço', align: 'center' },
        colors: ['#3B93A5', '#3B93A5', '#3B93A5', '#D43F97', '#D43F97', '#D43F97'],
        plotOptions: { treemap: { distributed: true, enableShades: false } },
      },
      situacaoAnaliseDinamica: null,
      helpSituacao: null,
      valorNCG: 0,
      valorCDG: 0,
      valorST: 0,
      cmbPerfil: 0,
      cmbPeriodoPerfil: 0,
      cmbBalancoPatrimonialVersao: 0,
      cmbTipoPeriodo: 0,
      anoMesReferencia: '',
      anoMesMesAnteriorReferencia: '',
      anoMesAnoAnteriorReferencia: '',
      anoMes3AnosAnteriorReferencia: '',
      anoMes5AnosAnteriorReferencia: '',
      anoMes10AnosAnteriorReferencia: '',
      showInfo: false,
      isProcessing: false,
    };
  },
  methods: {
    renderCoresADB(config) {
      let cor = '';
      if (config.tipo_grupo_analise_dinamica == 'CF') {
        cor = 'has-background-danger has-text-white';
      } else if (config.tipo_grupo_analise_dinamica == 'CO') {
        cor = 'has-background-info has-text-white';
      } else if (config.tipo_grupo_analise_dinamica == 'NC') {
        cor = 'has-background-warning';
      }
      return `is-size-7 ${cor}`;
    },
    filterRecords() {
      if (this.cmbPerfil == 0) {
        alert('Selecione um perfil');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Selecione um período');
        return;
      }
      if (this.cmbBalancoPatrimonialVersao == 0) {
        alert('Selecione um balanço patrimonial');
        return;
      }
      this.analiseDinamicaBalanco = [];
      this.series = [];
      this.situacaoAnaliseDinamica = null;
      this.helpSituacao = null;
      this.valorNCG = 0;
      this.valorCDG = 0;
      this.valorST = 0;
      http.get('balancoPatrimonialPeriodo/listar/', { params: { idPeriodoPerfil: this.cmbPeriodoPerfil.id } }).then((response) => {
        this.balancosPatrimoniaisPeriodo = response.data.results;
        if (this.balancosPatrimoniaisPeriodo.length) {
          this.showInfo = true;
          http.get('analiseDinamicaBalanco/listar/', {
            params: {
              idPeriodoPerfil: this.cmbPeriodoPerfil.id,
              idBalancoPatrimonialVersao: this.cmbBalancoPatrimonialVersao.id,
            },
          }).then((response) => {
            this.analiseDinamicaBalanco = response.data.results;
            this.series = [
              {
                data: [
                  { x: 'Ativo Circulante Financeiro', y: this.analiseDinamicaBalanco[0].valor_acf.toFixed(2) },
                  { x: 'Ativo Circulante Operacional', y: this.analiseDinamicaBalanco[0].valor_aco.toFixed(2) },
                  { x: 'Ativo Não Circulante', y: this.analiseDinamicaBalanco[0].valor_anc.toFixed(2) },
                  { x: 'Passivo Circulante Financeiro', y: this.analiseDinamicaBalanco[0].valor_pcf.toFixed(2) },
                  { x: 'Passivo Circulante Operacional', y: this.analiseDinamicaBalanco[0].valor_pco.toFixed(2) },
                  { x: 'Passivo Não Circulante', y: this.analiseDinamicaBalanco[0].valor_pnc.toFixed(2) },
                ],
              },
            ];
            if (this.analiseDinamicaBalanco[0].situacao == '1') {
              this.situacaoAnaliseDinamica = 'Excelente';
              this.helpSituacao = 'Empresa com este padrão de estrutura patrimonial revela excelente situação financeira...';
            } else if (this.analiseDinamicaBalanco[0].situacao == '2') {
              this.situacaoAnaliseDinamica = 'Sólida';
              this.helpSituacao = 'Empresa com este padrão de estrutura patrimonial revela sólida situação financeira...';
            } else if (this.analiseDinamicaBalanco[0].situacao == '3') {
              this.situacaoAnaliseDinamica = 'Insatisfatória';
              this.helpSituacao = 'Empresa com este padrão de estrutura patrimonial revela insatisfatória situação financeira...';
            } else if (this.analiseDinamicaBalanco[0].situacao == '4') {
              this.situacaoAnaliseDinamica = 'Alto risco';
              this.helpSituacao = 'Empresa com este padrão de estrutura patrimonial revela situação financeira de alto risco...';
            } else if (this.analiseDinamicaBalanco[0].situacao == '5') {
              this.situacaoAnaliseDinamica = 'Muito ruim';
              this.helpSituacao = 'Empresa com este padrão de estrutura patrimonial revela situação financeira muito ruim...';
            } else if (this.analiseDinamicaBalanco[0].situacao == '6') {
              this.situacaoAnaliseDinamica = 'Pré Insolvência';
              this.helpSituacao = 'Empresa com este padrão de estrutura patrimonial revela situação de pré-insolvência...';
            }
            this.valorNCG = this.analiseDinamicaBalanco[0].valor_ncg.toFixed(2);
            this.valorCDG = this.analiseDinamicaBalanco[0].valor_cdg.toFixed(2);
            this.valorST = this.analiseDinamicaBalanco[0].valor_st.toFixed(2);
          });
        } else {
          this.showInfo = false;
          alert('Não há dados associados aos parâmetros informados!');
        }
      });
    },
    selectTipoPeriodo() {
      this.cmbPerfil = 0;
      this.cmbPeriodoPerfil = 0;
      this.cmbBalancoPatrimonialVersao = 0;
      this.balancosPatrimoniaisPeriodo = [];
      this.anoMesReferencia = '';
      this.anoMesMesAnteriorReferencia = '';
      this.anoMesAnoAnteriorReferencia = '';
      this.anoMes3AnosAnteriorReferencia = '';
      this.anoMes5AnosAnteriorReferencia = '';
      this.anoMes10AnosAnteriorReferencia = '';
      this.showInfo = false;
    },
    selectPerfil() {
      http.get('periodoPerfil/listar/', {
        params: {
          idPerfil: this.cmbPerfil,
          idTipoPeriodo: this.cmbTipoPeriodo,
          semPaginacao: 'S',
        },
      }).then((response) => {
        this.periodosPerfis = response.data.results;
        if (!this.periodosPerfis.length) {
          alert('Não há períodos associados ao perfil selecionado!');
          this.cmbPeriodoPerfil = 0;
        }
      });
    },
    selectPeriodoPerfil() {
      http.get('balancoPatrimonialVersao/listarBalancos/', {
        params: { idVersaoPlanoContas: this.cmbPeriodoPerfil.versao_plano_contas.id },
      }).then((response) => {
        this.balancosPatrimoniais = response.data.results;
        this.anoMesReferencia = this.cmbPeriodoPerfil.periodo.data;
        this.anoMesMesAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_mes_anterior;
        this.anoMesAnoAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_ano_anterior;
        this.anoMes3AnosAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_3anos_anteriores;
        this.anoMes5AnosAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_5anos_anteriores;
        this.anoMes10AnosAnteriorReferencia = this.cmbPeriodoPerfil.periodo.data_10anos_anteriores;
        if (!this.balancosPatrimoniais.length) {
          alert('Não há balanços patrimoniais associados a versão associada ao período selecionado!');
          this.cmbBalancoPatrimonialVersao = 0;
        }
      });
      if (this.cmbBalancoPatrimonialVersao != 0) {
        this.filterRecords();
      }
    },
    processar() {
      if (this.cmbPerfil == 0) {
        alert('Perfil não selecionado!');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Período não selecionado!');
        return;
      }
      if (this.cmbBalancoPatrimonialVersao == 0) {
        alert('Balanço patrimonial não selecionado!');
        return;
      }
      if (window.confirm('Confirma o processamento do balanço patrimonial?')) {
        this.isProcessing = true;
        http.put('/balancoPatrimonialPeriodo/processar/' + this.cmbPeriodoPerfil.id, this.cmbBalancoPatrimonialVersao).then((response) => {
          if (response.status == 204) {
            this.isProcessing = false;
            this.filterRecords();
            alert('Processamento concluído!');
          }
        }).catch((e) => {
          this.isProcessing = false;
          console.log(e);
          alert('Erro ao processar o balanço patrimonial.');
        });
      }
    },
  },
  mounted() {},
  created() {
    http.get('compartilharPerfis/listarPerfis').then((response) => {
      this.perfisUsuario = response.data.results;
    });
    http.get('tiposPeriodo/listar').then((response) => {
      this.tiposPeriodo = response.data.results;
    });
  },
};
</script>

<style scoped>
</style>